import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,[_c(VLayout,{attrs:{"text-xs-center":"","wrap":""}},_vm._l((_vm.events),function(event){return _c('timeline-event',{key:event.id,attrs:{"event":event},on:{"click-likes":_vm.showLikers}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }